import Vue from 'vue'

// 排行榜
export const getStatistic = params => {
  return Vue.fetch.post('/apiv1/api/statistic', params)
}

// 调用总数
export const getStatisticTotal = params => {
  return Vue.fetch.post('/apiv1/api/statistic/total', params)
}

// api 调用详情
export const getStatisticApiAggs = params => {
  return Vue.fetch.post('/apiv1/api/statistic/api_aggs', params)
}

// app 调用详情
export const getStatisticAppAggs = params => {
  return Vue.fetch.post('/apiv1/api/statistic/app_aggs', params)
}

// 接口调用数量统计
export const getStatisticTotalTrend = params => {
  return Vue.fetch.post('/apiv1/api/statistic/total/trend', params)
}



// WEBPACK FOOTER //
// ./src/services/statisticsApi.js